import type { SiteSection } from '../domains/site';

type ImageCapableSection = SiteSection & {
  imageUrl?: string;
  imageAlt?: string;
  imageAssetId?: string;
};

const SECTION_IMAGE_LABELS: Partial<Record<SiteSection['type'], string>> = {
  hero: 'メインビジュアル',
  'feature-list': '特長一覧',
  problem: '課題紹介',
  solution: '解決のポイント',
  benefit: '得られる価値',
  services: '提供内容',
  features: '選ばれる理由',
  feature_list: '特長一覧',
  reasons: '選ばれる理由',
  proof: '信頼につながる実績',
  review: 'お客様の声',
  pricing: '料金の考え方',
  steps: 'ご利用の流れ',
  faq: 'よくある質問',
  cta: 'お問い合わせエリア',
  use_cases: '活用イメージ',
  comparison: '比較ポイント',
  people: '人や体制',
  message: 'メッセージ',
  target_audience: 'こんな方におすすめ',
  overview: '概要',
  speaker: '登壇者紹介',
  instructor: '講師紹介',
  work_style: '働き方',
  course_or_curriculum: '学べる内容',
  offer: '特典・ご案内',
  access: 'アクセス',
};

function sanitizeText(value?: string) {
  return value?.trim() ?? '';
}

function getSectionPrimaryText(section: SiteSection) {
  if ('title' in section && typeof section.title === 'string' && section.title.trim()) {
    return section.title.trim();
  }

  if ('headline' in section && typeof section.headline === 'string' && section.headline.trim()) {
    return section.headline.trim();
  }

  return '';
}

export function supportsSectionImage(section: SiteSection): section is ImageCapableSection {
  return Boolean(SECTION_IMAGE_LABELS[section.type]);
}

export function getSectionImageTypeLabel(sectionType: SiteSection['type'] | string) {
  return SECTION_IMAGE_LABELS[sectionType as SiteSection['type']] ?? '画像';
}

export function getSectionImageUrl(section: SiteSection) {
  return supportsSectionImage(section) ? sanitizeText(section.imageUrl) : '';
}

export function getSectionImageAlt(section: SiteSection) {
  return supportsSectionImage(section) ? sanitizeText(section.imageAlt) : '';
}

export function getSectionImageAssetId(section: SiteSection) {
  return supportsSectionImage(section) ? sanitizeText(section.imageAssetId) : '';
}

export function getSectionImageLabel(section: SiteSection) {
  if (section.type === 'hero' || section.type === 'cta') {
    return getSectionImageTypeLabel(section.type);
  }

  return getSectionPrimaryText(section) || getSectionImageTypeLabel(section.type);
}
